import React, { useState } from "react";
import "./Schedule.scss";
import { width } from "@fortawesome/free-solid-svg-icons/fa0";
import RepairOrders from "../../components/repairOrder/RepairOrders";
import PopInWindow from "../../components/popInWindow/PopInWindow";
import CompletedIcon from "../../assets/icons/CompletedIcon";
import InprogressIcon from "../../assets/icons/InprogressIcon";
import DelayedIcon from "../../assets/icons/DelayedIcon";
import UnassignedIcon from "../../assets/icons/UnassignedIcon";
import PopInNavIcon from "../../assets/icons/PopInNavIcon";
import Stage from "../../components/stage/Stage";
import StatusBar from "../../components/statusBar/StatusBar";
const Schedules = () => {
  const [reloadStatusBar, setReloadStatusBar] = useState(false);
  const [ShowPopin, setShowPopin] = useState(false);
  const [hideRoListState, setHideRoListState] = useState(false);
  //const [numberOfRos, setNumberOfRos] = useState(0);
  const openPopin = () => {
    setShowPopin(!ShowPopin);
  };

  const hideRoList = ()=>{
    setHideRoListState(true)
  }

  const dismissPopup = ()=>{
    setShowPopin(false)
    setHideRoListState(false)
  }

  const closeRepairOrderImportPopup = () => {
    setShowPopin(false);
  };
  const triggerStatusBarReload = () => {
    setReloadStatusBar(prevState => !prevState); // Toggle state to force re-render
  };

  /*const getNumberofROs=(ros)=>{
    setNumberOfRos(ros)
  }*/
  return (
    <div className="schedules">
      <StatusBar showRoList={true} openPopin = {openPopin} reload={reloadStatusBar}/>
      <div className="schedule-table">
        <Stage triggerStatusBarReload={triggerStatusBarReload} closePopin={closeRepairOrderImportPopup}/>
      </div>
      {ShowPopin && (
        <div className={hideRoListState ? "hide-popup":""}>
          <PopInWindow title={`Repair Orders `} closePopin={openPopin}>
            <RepairOrders hideRoList={hideRoList} dismissPopup={dismissPopup} triggerStatusBarReload={triggerStatusBarReload} />
          </PopInWindow>
        </div>
      )}
    </div>




  );
};

export default Schedules;
